module.exports = __webpack_public_path__ + "static/img/weibo.0e8ed77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/weibo.png
// module id = tCPD
// module chunks = 39